import { Button, DateField } from "@dash/form";
import { useDeviceType } from "@dash/mq";
import { dateStringsInRange, toDateString } from "@legacy-megarax/common";
import { workDayResource } from "@legacy-megarax/crm-contracts";
import { useProfilesDictionary } from "@legacy-megarax/iam-webapp";
import { useResourceProviderV2 } from "@legacy-megarax/react-client";
import { commonErrorsMap, useSnackbarErrorHandler } from "@legacy-megarax/ui-components";
import fileDownload from "js-file-download";
import _ from "lodash";
import React from "react";
import { MdOutlineDownload } from "react-icons/md";
import { useQuery } from "react-query";

import { reportToCsv } from "./reportToCsv";

export type DateRange = [since: Date | null, until: Date | null];

export const MilageReportDialog = () => {
  const { isMobile } = useDeviceType();

  const [dateRange, setDateRange] = React.useState<DateRange>([null, null]);
  const workDayProvider = useResourceProviderV2(workDayResource);

  const errorHandler = useSnackbarErrorHandler({ ...commonErrorsMap });

  const isDateRangeSelected = dateRange[0] !== null && dateRange[1] !== null;

  const { data: report } = useQuery(
    ["milageReport", ...dateRange],
    () =>
      workDayProvider
        .milageReport({
          since: toDateString(dateRange[0] as Date),
          until: toDateString(dateRange[1] as Date),
        })
        .mapError(errorHandler)
        .then((r) => r.assertOk().value),
    {
      enabled: isDateRangeSelected,
    },
  );

  const profilesDictionary = useProfilesDictionary(report?.users.map((p) => ({ id: p.userId })));

  const download =
    report &&
    profilesDictionary &&
    (() => {
      if (dateRange[0] === null || dateRange[1] === null) return;
      const csv = reportToCsv(
        report,
        _.mapValues(profilesDictionary, (v) => (v?.fullName ? v?.fullName : v?.user?.email)),
        dateStringsInRange(dateRange[0], dateRange[1]),
      );
      fileDownload(csv, `przejechane_kilometry.csv`);
    });

  return (
    <div css={{ display: "flex", flexDirection: "column", gap: "2rem", minWidth: isMobile ? "unset" : "20rem" }}>
      <div css={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
        <DateField onChange={(date) => setDateRange([date, dateRange[1]])} value={dateRange[0]} label="Od" />
        <DateField onChange={(date) => setDateRange([dateRange[0], date])} value={dateRange[1]} label="Do" />
      </div>
      <Button onClick={download} isDisabled={download === undefined} icon={<MdOutlineDownload />}>
        Pobierz CSV
      </Button>
    </div>
  );
};
